export const TEMPLATE_XFLOW_MESSAGE_TEMPLATE_ID = 'twc-sidenav-banner';
export const TEMPLATE_XFLOW_PLACEMENT_ID = 'confluence-side-nav';

export const TEMPLATE_XFLOW_FILTER_NAME = 'twc-sidenav-banner-template-xflow-reminder-state-filter';

export const TEMPLATE_XFLOW_FILTER_REASONS = {
	DENIED_REMINDER_DISMISSED: 'reminder-state-dismissed',
	FAILED_MISSING_DEPENDENCIES: 'missing-filter-dependencies',
	FAILED_UNEXPECTED_REMINDER_STATE: 'unexpected-reminder-state',
	FAILED_REMINDER_LOOKUP: 'reminder-state-lookup-failed',
	SKIPPED_OTHER_PLACEMENT: 'other-placement',
	SKIPPED_OTHER_MESSAGE: 'other-message',
} as const;

export const TEMPLATE_XFLOW_HYDRATION_FAILURE_METRIC = 'twc-sidenav-banner.conf.error.count';

export const TEMPLATE_XFLOW_HYDRATION_FAILURE_REASONS = {
	TENANT_ID_NOT_AVAILABLE: 'tenant-id-not-available',
	ORG_ID_NOT_AVAILABLE: 'template-xflow-org-id-not-available',
	TAP_TRAITS_UNAVAILABLE: 'template-xflow-tap-traits-unavailable',
} as const;

export const TEMPLATE_XFLOW_RENDER_EXPERIENCE = 'twcg-2112-confluence-template-xflow-banner-render';

export const TEMPLATE_XFLOW_RENDER_FAILURE_REASON = 'renderer-error';

export const TEMPLATE_XFLOW_RENDER_ABORT_REASONS = {
	DELIVERY_CANCELLED: 'delivery-cancelled',
	POST_OFFICE_TEARDOWN: 'post-office-teardown',
	COMPONENT_UNMOUNTED: 'component-unmounted',
} as const;
